import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Button } from "../../atoms/common";
import PropTypes from "prop-types";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation, Autoplay } from "swiper";

const Carrousel = (props) => {
  const {
    children,
    btnNextClasses,
    btnPrevClasses,
    duration,
    navigate,
    paginate,
    itemCount,
    iconNextClasses,
    iconPrevClasses,
  } = props;
  return (
    <Swiper
      spaceBetween={0}
      slidesPerView={itemCount || 1}
      loop={true}
      loopFillGroupWithBlank={true}
      navigation={
        !navigate
          ? false
          : {
              nextEl: ".swipers-button-next",
              prevEl: ".swipers-button-prev",
            }
      }
      pagination={
        !paginate
          ? false
          : {
              clickable: true,
            }
      }
      autoplay={
        !duration
          ? false
          : {
              delay: duration,
              disableOnInteraction: true,
            }
      }
      modules={[Pagination, Navigation, Autoplay]}
      className="mySwiper"
    >
      {React.Children.map(children, (child) => (
        <SwiperSlide className="bg-transparent">{child}</SwiperSlide>
      ))}
      <Button classes={`swipers-button-prev ${btnPrevClasses}`}>
        <span
          className={
            iconPrevClasses ||
            `inline-flex justify-center items-center w-8 h-8 rounded-full sm:w-10 sm:h-10 bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none`
          }
        >
          <svg
            className="w-5 h-5 text-white sm:w-6 sm:h-6 dark:text-gray-800"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            ></path>
          </svg>
          <span className="hidden">Previous</span>
        </span>
      </Button>
      <Button classes={`swipers-button-next ${btnNextClasses}`}>
        <span
          className={
            iconNextClasses ||
            `inline-flex justify-center items-center w-8 h-8 rounded-full sm:w-10 sm:h-10 bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none`
          }
        >
          <svg
            className="w-5 h-5 text-white sm:w-6 sm:h-6 dark:text-gray-800"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            ></path>
          </svg>
          <span className="hidden">Next</span>
        </span>
      </Button>
    </Swiper>
  );
};

Carrousel.propTypes = {
  children: PropTypes.elementType,
  btnNextClasses: PropTypes.string,
  btnPrevClasses: PropTypes.string,
  duration: PropTypes.number,
  navigate: PropTypes.bool,
  paginate: PropTypes.bool,
  itemCount: PropTypes.number,
  iconNextClasses: PropTypes.string,
  iconPrevClasses: PropTypes.string,
};

export default Carrousel;
